import React from 'react'
import PropTypes from 'prop-types'
import { Redirect } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useIntl } from 'react-intl'
import dayjs from 'dayjs'
import 'dayjs/locale/pt-br'

import FullPageLoader from '~/components/fullpage-loader/fullpage-loader'

import { CAMPAIGN_STATUS } from '~/helpers/constants'
import { getCampaignConfig } from '~/store/modules/campaign/actions'
import { setContentMode } from '~/store/modules/config/actions'
import { isEmbedMode } from '~/helpers/contentMode'

import { resetVoucher } from '~/store/modules/voucher/actions'

const utc = require('dayjs/plugin/utc')
dayjs.extend(utc)
dayjs.locale('pt-br')

const Initial = (props) => {
  const campaignId = props.match.params.campaignId || false

  const queryParams = new URLSearchParams(window.location.search)
  const contentModeCampaign = queryParams.get('contentMode') || ''

  const dispatch = useDispatch()
  const { formatMessage } = useIntl()

  const campaign = useSelector((state) => state.campaignReducers.campaign)
  const getCampaignConfigLoading = useSelector((state) => state.campaignReducers.loadings.getCampaignConfig)
  const getCampaignConfigError = useSelector((state) => state.campaignReducers.errors.getCampaignConfig)
  const getCampaignConfigAttempts = useSelector((state) => state.campaignReducers.attempts.getCampaignConfig)

  React.useEffect(() => {
    if (
      !campaign?.campaignId &&
      !getCampaignConfigLoading &&
      !getCampaignConfigError &&
      getCampaignConfigAttempts === 0
    ) {
      dispatch(resetVoucher())

      const queryStringParameters = props?.location?.search || ''

      dispatch(
        getCampaignConfig({
          campaignId,
          appAccess:
            (queryStringParameters.includes('APP=oBot1c4r10') && new Date('2022-09-29T23:59:00') > new Date()) ||
            queryStringParameters.includes('APP=1qwdM2z6RcsyEIEqOwHkqbHp50BCJSryd1c9KL8ln_Y0')
        })
      )

      if (isEmbedMode(contentModeCampaign)) {
        dispatch(setContentMode({ contentMode: contentModeCampaign }))
        localStorage.setItem('contentMode', contentModeCampaign)
      } else {
        localStorage.removeItem('contentMode')
      }
    }
  }, [
    dispatch,
    campaign,
    campaignId,
    getCampaignConfigLoading,
    getCampaignConfigError,
    getCampaignConfigAttempts,
    props,
    contentModeCampaign
  ])

  if (
    campaign?.campaignStatus === CAMPAIGN_STATUS.ENABLED &&
    !getCampaignConfigLoading &&
    !getCampaignConfigError &&
    getCampaignConfigAttempts === 1 &&
    campaign?.campaignId &&
    campaign?.steps?.length &&
    campaign?.activeConsumerModule
  ) {
    return <Redirect to={`/${campaignId}/${campaign.steps[0]?.view}`} />
  }

  if (
    campaign?.campaignStatus === CAMPAIGN_STATUS.DISABLED ||
    getCampaignConfigError ||
    (getCampaignConfigAttempts === 1 && !campaign?.activeConsumerModule)
  ) {
    return <Redirect to={campaignId ? `/${campaignId}/ERRO_ACESSO` : '/CAMPANHA_INVALIDA/ERRO_ACESSO'} />
  }

  return <FullPageLoader text={formatMessage({ id: 'Carregando' })} />
}

Initial.propTypes = {
  campaignId: PropTypes.string,
  location: PropTypes.shape({
    search: PropTypes.string
  }),
  match: PropTypes.shape({
    params: PropTypes.shape({
      campaignId: PropTypes.string
    })
  })
}

export default Initial
